// Mouse events are "captured" by iframes. This is a problem for e.g. sliders,
// when the thumb is let go when the cursor is over an iframe. We work around
// the problem by setting pointer-events: none on those elements on mousedown.
// This is more complex than it could be because it does as much as possible
// lazily.
export default {
    dependencies: ['$element'],
    callable(ele) {
        function getIframeEles() {
            return [...ele.querySelectorAll('iframe')];
        }

        function handleWindowMouseDown() {
            getIframeEles().forEach(ele =>
                ele.addEventListener('mouseenter', handleElementMouseEnter)
            );
            window.addEventListener('mouseup', handleWindowMouseUp, true);
        }

        function handleElementMouseEnter({ target }) {
            target.style.pointerEvents = 'none';
        }

        function handleWindowMouseUp() {
            getIframeEles().forEach(ele => {
                ele.style.removeProperty('pointer-events');
                ele.removeEventListener('mouseenter', handleElementMouseEnter);
            });
            window.removeEventListener('mouseup', handleWindowMouseUp, true);
        }

        window.addEventListener('mousedown', handleWindowMouseDown, true);
    },
};



// WEBPACK FOOTER //
// ./controllers/iframeMouseupIgnore.js